export const SEGMENTS_FAMILY_NAME = "Segments";
export const SEGMENTS_METRICS = {
    Visits: {
        name: "SegmentsMonthlyVisits",
        type: "SegmentsMonthlyVisitsGraph",
    },
    UniqueUsers: { name: "SegmentsUniqueVisitors", type: "SegmentsUniqueVisitorsGraph" },
    PagesViews: {
        name: "SegmentsPageViews",
        type: "SegmentsPageViewsGraph",
    },
    PagePerVisit: {
        name: "SegmentsPagePerVisit",
        type: "SegmentsPagePerVisitGraph",
    },
    Duration: {
        name: "SegmentsVisitDuration",
        type: "SegmentsVisitDurationGraph",
    },
    BounceRate: {
        name: "SegmentsBounceRate",
        type: "SegmentsBounceRateGraph",
    },
    TrafficShare: {
        name: "SegmentsTrafficShare",
        type: "SegmentsTrafficShareGraph",
    },
};
export const SEGMENTS_COMPARISON_METRICS = {
    Visits: {
        name: "SegmentsGroupMonthlyVisits",
        type: "SegmentsGroupMonthlyVisitsGraph",
    },
    SegmentShare: {
        name: "SegmentsGroupTrafficShare",
        type: "SegmentsGroupTrafficShareGraph",
    },
    UniqueUsers: { name: "SegmentsUniqueVisitorsGroup", type: "SegmentsUniqueVisitorsGroupGraph" },
    PagesViews: {
        name: "SegmentsPageViewsGroup",
        type: "SegmentsPageViewsGroupGraph",
    },
    PagePerVisit: {
        name: "SegmentsPagePerVisitGroup",
        type: "SegmentsPagePerVisitGroupGraph",
    },
    VisitDuration: {
        name: "SegmentsVisitDurationGroup",
        type: "SegmentsVisitDurationGroupGraph",
    },
    BounceRate: {
        name: "SegmentsBounceRateGroup",
        type: "SegmentsBounceRateGroupGraph",
    },
};

export const SEGMENTS_GEO_METRICS = {
    SEGMENTS_GEOGRAPHY: "SegmentsGeography",
    SEGMENTS_GEOGRAPHY_GROUP: "SegmentsGeographyGroup",
};

export const SEGMENTS_GROUP_METRICS = {
    SegmentsGroupMonthlyVisits: true,
    SegmentsUniqueVisitorsGroup: true,
    SegmentsGroupTrafficShare: true,
    SegmentsPageViewsGroup: true,
    SegmentsPagePerVisitGroup: true,
    SegmentsVisitDurationGroup: true,
    SegmentsBounceRateGroup: true,
};

export const SEGMENTS_GROUP_TOTAL_METRICS = {
    SegmentsGroupMonthlyVisits: true,
    SegmentsGroupTrafficShare: true,
    SegmentsUniqueVisitorsGroup: true,
};

export const SEGMENTS_TOTAL_METRICS = {
    SegmentsMonthlyVisits: true,
    SegmentsTrafficShare: true,
    SegmentsUniqueVisitors: true,
    SegmentsGeography: true,
};
